import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { ModalBody } from 'ui/modal';
import { body2, fontWeights, spacing, subtitle2 } from 'ui/theme';

export const StyledModalBody = styled(ModalBody)`
  ${subtitle2};
  font-weight: ${fontWeights.bold};
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

export const StyledBodyText = styled.div`
  ${body2};
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const FormSubsection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
`;
